import { Metadata } from '@workspaces/types'
import { METADATA } from './flavours/meta'

export const getAppMetadata = (): Metadata.AppMetadata => METADATA

export const getAppMetadataLanguages = (): Metadata.Languages =>
  getAppMetadata().languages

export const getAppMetadataLocalStorageKeys = (): Metadata.LocalStorageKeys =>
  getAppMetadata().local_storage_keys

export const isMultiCountry = (): boolean => {
  return getAppMetadata().plan_filters.widget_countries.enable
}
